
import { mapState } from "vuex";

import { gtmEventMixin } from "~/mixins";

export default {
  mixins: [gtmEventMixin],

  props: {
    styles: { type: Object, default: () => {} },
    product: { type: Object, required: true },
    images: { type: Array, default: () => [] },
    buttonContent: { type: String, default: "" },
    selectedVariant: { type: Object, default: () => {} },
    variantImageSrc: { type: String, required: true },
    priorityCampaign: { type: Object, default: () => {} },
  },

  data: () => ({ isScrolled: false, showStickyHeader: false }),

  computed: {
    ...mapState(["siteConfig"]),
    addToCartProps() {
      return {
        selectedVariant: this.selectedVariant,
        product: this.product,
        styles: this.styles,
        buttonContent: this.buttonContent,
      };
    },
    showCompareAtPrice() {
      return this.canShowCompareAtPrice(
        this.priorityCampaign,
        this.selectedVariant.compareAtPrice,
        this.selectedVariant.price
      );
    },
  },

  methods: {
    emitGTMEvent() {
      const dataSet = {
        ...this.selectedVariant,
        name: this.product.title,
        collections: this.product.collections,
        brand: this.product.brand_list,
        available: this.selectedVariant?.availableForSale,
        type: this.productType,
      };
      this.gtmProductDetailView(dataSet);
    },
    emitGTMAddToCartEvent() {
      const dataSet = {
        ...this.selectedVariant,
        name: this.product.title,
        collections: this.product.collections,
        brand: this.product.brand_list,
        available: this.selectedVariant?.availableForSale,
        type: this.product.productType,
      };
      this.gtmAddToCart(dataSet);
    },
    catchAddToCartScroll(event, el) {
      this.isScrolled = true;
      return true;
    },
    visibilityChanged(isVisible, entry) {
      const isAboveTopSection =
        entry.target.getBoundingClientRect().y < this.siteConfig.headerHeight;

      this.showStickyHeader =
        this.$device.isMobile || this.isMobile ? !isVisible : isAboveTopSection;
    },
  },
};
